<template>
<select class="form-control" v-model="selectedCompany" @change="change">
  <option v-if="value === null" :value="null">Seleziona un'azienda</option>
  <option v-for="(company, i) of sortedCompanies" :key="i" :value="company.id">
    {{company.name}}
  </option>
</select>
</template>
<script>

export default {
  name: 'company-context-select',
  props: {
    companies: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
    },
  },
  computed: {
    selectedCompany: {
      get: function () {
        return this.value?.id || null;
      },
      set: function (val) {},
    },
    sortedCompanies () {
      return this.companies.slice().sort((a, b) => {
        if (a.name === b.name) {
          return 0;
        }

        return (a.name < b.name) ? -1 : 1;
      });
    },
  },
  methods: {
    change ($event) {
      const company = this.companies.find(c => c?.id?.toString() === $event.target?.value?.toString()) || null;
      this.$emit('input', company);
      this.$router.push({ name: 'operative-company', params: { id: company.id } });
    },
  },
};

</script>

<style lang="scss">

.btn.btn-primary.dropdown {
  padding: 0 !important;

  .dropdown-toggle {
    background: $mercurio-blue;
    border: none;
    padding: 4px 15px 4px 30px;
    font-weight: bold;

    &::after {
      margin-left: 15px;
      border-top-width: 0.5em;
      border-right-width: 0.3em;
      border-left-width: 0.3em;
      vertical-align: 0.10em;
    }
  }

  .dropdown-menu {
    min-width: 100%;
    border: none;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    background: white;

    .dropdown-item {
      text-align: right;

      &.active,
      &:active {
        background: transparent;
        color: inherit;
        font-weight: bold;
      }

      &.hover,
      &:hover {
        background: transparent;
      }
    }
  }
}

</style>
